var _desc, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSuperAdmin = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Single Neutral Actions Setting Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M16.313 17.031a1.437 1.437 0 1 0 2.874 0 1.437 1.437 0 1 0-2.874 0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m18.971 11.47.424 1.392a.95.95 0 0 0 1.124.653l1.412-.327a1.283 1.283 0 0 1 1.221 2.126l-.988 1.065a.96.96 0 0 0 0 1.3l.988 1.065a1.283 1.283 0 0 1-1.221 2.126l-1.412-.328a.953.953 0 0 0-1.119.658l-.424 1.392a1.275 1.275 0 0 1-2.442 0l-.429-1.392a.953.953 0 0 0-1.124-.653l-1.412.328a1.283 1.283 0 0 1-1.221-2.126l.988-1.065a.96.96 0 0 0 0-1.3l-.988-1.065a1.283 1.283 0 0 1 1.221-2.126l1.412.327a.95.95 0 0 0 1.124-.653l.424-1.392a1.275 1.275 0 0 1 2.442-.005M3.25 4.75a4.25 4.25 0 1 0 8.5 0 4.25 4.25 0 1 0-8.5 0M9.5 17.5h-9a7 7 0 0 1 10.783-5.89"
})));
export { SvgSuperAdmin as ReactComponent };
export default __webpack_public_path__ + "assets/images/superAdmin.svg";